module.exports = __webpack_public_path__ + "static/media/6.16da8653.JPG";